module.exports = __webpack_public_path__ + "img/audio_thumbnail_ida.cdb59cd4.png";